const smooth = (value: number) => {
  const t = Math.max(0, Math.min(1, value));
  return t * t * (3 - 2 * t);
};

const noise = (value: number) => {
  const n = Math.sin(value * 127.1 + 311.7) * 43758.5453123;
  return n - Math.floor(n);
};

// Independent drifting destinations avoid visible spiral lanes through the swarm.
export function swarmPosition(
  homeX: number,
  homeY: number,
  radius: number,
  padding: number,
  spread: number,
  time: number,
  seed: number,
  group: number,
) {
  const limit = Math.max(0, radius - padding);
  const identity = seed * 971 + group * 37;
  const clock = time * (0.19 + noise(identity + 5) * 0.19) + noise(identity + 11) * 100;
  const step = Math.floor(clock);
  const blend = smooth(clock - step);
  const destination = (index: number) => {
    const angle = noise(identity + index * 17.3) * Math.PI * 2;
    const distance = limit * 0.86 * Math.sqrt(noise(identity + index * 29.7 + 83));
    return { x: Math.cos(angle) * distance, y: Math.sin(angle) * distance };
  };
  const from = destination(step);
  const to = destination(step + 1);
  const driftX = from.x + (to.x - from.x) * blend;
  const driftY = from.y + (to.y - from.y) * blend;
  const amount = Math.max(0, Math.min(1, spread));
  let x = homeX + (driftX - homeX) * amount;
  let y = homeY + (driftY - homeY) * amount;
  const distance = Math.hypot(x, y);
  if (distance > limit && distance > 0) {
    x *= limit / distance;
    y *= limit / distance;
  }
  return { x, y };
}
